<template>
  <div class="case">
    <div class="content" v-for="item in caseData">
      <div class="pic">
        <img :src="item.url" alt="">
        <div class="logo" v-if="item.logo">
          <img :src="item.logo" alt="">
        </div>
        <h3>
          {{item.title}}
        </h3>
        <!-- <div class="pos-left">地点:{{item.address}}</div>
        <div class="pos-right">面积:{{item.arceage}}</div> -->
      </div>
      <span v-for="list1 in item.introduce">{{list1}}</span>
      <!-- <h4 v-if="item.subtitle.length">{{item.subtitle}}</h4>
      <p v-for="list2 in item.msg">{{list2}}</p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "case",
  data: () => ({
    caseData: [
			{
			  logo: require('../../assets/case/l1.png'),
			  url: require('../../assets/case/b1.png'),
			  title: '远洋集团',
			  introduce: ['远洋集团为内地在港上市房地产公司十强之一。创立于1993年，并于2007年9月28日在香港联合交易所主板上市。昊楼科技2018年起，与远洋事业二部、远洋不动产的众多项目，包含远洋锐中心、长安国际中心、远洋国际中心等开启资管+招商+运营数字化合作。']
			},
      {
        logo: require('../../assets/case/l2.png'),
        url: require('../../assets/case/b2.png'),
        title: '京东方集团',
        introduce: ['京东方集团旗下智慧园区（UBP园区+UCP园区）和空间品牌零秒空间，2019年基于1号楼·运营云打造“运营管理标准化”“客户服务精细化”“业务流程在线化”“管理数据可视化”的新型管理体系，管理范围包括十余个项目，总管理面积超过六十万方。服务平台有：基础服务、空间租赁、增值服务、生态服务、生活服务、社群互动、品牌宣传等。']
      },
      {
        logo: require('../../assets/case/l3.png'),
        url: require('../../assets/case/b3.png'),
        title: '上海国际机场股份有限公司',
        introduce: ['上海国际机场股份有限公司于1997 年5 月16 日成立。浦东机场是上海两大国际机场之一，与北京首都国际机场、香港国际机场并称中国三大国际机场。昊楼为其辖区内经营的多种类型资源（业务用房、贵宾室、售票柜台、保险柜台、中转柜台、经营服务项目场地及广告阵地等）提供专业的资产管理系统，也为其打造经营计划全流程管理系统。']
      },
      {
        logo: require('../../assets/case/l4.png'),
        url: require('../../assets/case/b4.png'),
        title: '中信集团',
        introduce: ['昊楼科技与中信集团合作始于2020年，以招商+资管数字化为主，合作范围包括中信集团旗下的所有资产项目。其中，中信大厦（又名中国尊）高达528米，建筑面积超过50万方，为北京第一高楼，同时也是北京新地标建筑。']
      },
      {
        logo: require('../../assets/case/l5.png'),
        url: require('../../assets/case/b5.png'),
        title: '德必集团',
        introduce: ['德必集团，（股票代码：300947）国内TOP3的产业园区运营服务商，采用“承租运营” “受托运营” “参股运营”等灵活多样的经营模式，在全球运营管理70+园区,其物业会员增值业务收入占比超20%，是产业园区运营典范。早在18年底，德必就与昊楼签订战略合作协议，持续合作资管数字化体系至今。']
      },
      {
        logo: require('../../assets/case/l6.png'),
        url: require('../../assets/case/b6.png'),
        title: '凯龙瑞',
        introduce: ['凯龙瑞是一家专门从事投资管理及资产管理的专业机构。凯龙瑞集团成立于2004年，办公室分布于上海、香港、北京、成都、大连和广州。至今已投资管理了56个项目，总投资超过人民币269亿元，其中32个项目已成功退出并实现了良好的业绩。双方于2021年开启资产+运营平台的合作。']
      },
      {
        logo: require('../../assets/case/l7.png'),
        url: require('../../assets/case/b7.png'),
        title: '浦东软件园',
        introduce: ['浦东软件园，成立于1992年7月，由原信息产业部和上海市人民政府共同组建，是全国Top3级别软件园区。基于昊楼园区资产与客户产品的灵活性与易用性，浦软于2022年初与昊楼展开“招商+资管”体系合作，并将逐步在所有园区推广。']
      },
      {
        logo: require('../../assets/case/l8.png'),
        url: require('../../assets/case/b8.png'),
        title: '万通地产',
        introduce: ['万通地产，是以房产开发为主的民营企业。万通地产拥有"新新家园系列"、"国际系列"、"华府系列"、"公馆系列"等高端住宅品牌，并成为地标性建筑之一。以“万通中心”为核心的商用物业品牌,现已在北京、天津、上海、杭州等高价值城市落地，于2020年与昊楼科技达成合作，对旗下所有存量资产进行管理，提高集团管理效率及项目核心竞争力。']
      },
      {
        logo: require('../../assets/case/l9.png'),
        url: require('../../assets/case/b9.png'),
        title: '鼎好DH3',
        introduce: ['鼎好DH3，位于中关村核心区的现代科技商务综合体，定位国际科创生态交互平台，将极具想象力的空间，交予梦想改变世界的创新企业。','昊楼科技基于鼎好DH3资产经营管理的要求，与其共建“智慧楼宇资产管理平台”，进一步推动了鼎好DH3的智慧化管理，打造精细化经营管理能力，为其资产保值增值奠定扎实基础。']
      },
      {
        logo: require('../../assets/case/l10.png'),
        url: require('../../assets/case/b10.png'),
        title: '环球港',
        introduce: ['上海·环球港，是月星集团斥巨资打造的从家居产业向大型城市商业综合体转型的首部力作，于2013年上半年在上海震撼开业。该项目作为集"商业、旅游、文化" 三大中心功能于一体的全球中心城区最大的购物中心，总建筑面积达48万平方米，商业面积近32万平方米，高级办公楼12万平方米，五星级酒店面积约4万平方米。昊楼与环球港合作的客户服务平台于2022上线开始使用。']
      },
      {
        logo: require('../../assets/case/l11.png'),
        url: require('../../assets/case/b11.png'),
        title: '三峡集团',
        introduce: ['三峡资产业务主要包括房产经营管理、土地开发、低效和无效资产盘活处置、新能源开发与运营、产权经纪和绿色农业生产等，在北京、上海、江苏南京、湖北宜昌等地拥有写字楼等房产建筑面积约31.4万平方米；在北京、上海、天津、湖北宜昌、黑龙江富锦等地拥有5万多亩土地资源，并数次获得最佳组织奖和优质服务奖等荣誉。昊楼资管云系统的上线，大大提升了三峡资产的资产管理精细化和业务流转效率。']
      },
      {
        logo: require('../../assets/case/l12.png'),
        url: require('../../assets/case/b12.png'),
        title: '长江创服&腾讯众创空间',
        introduce: ['长江创服，腾讯旗下众创空间,国内领先的科创服务商和产业运营平台，拥有全链条创新创业运营能力，通过产业投资、孵化、服务、培训四大引擎，全面赋能企业发展。2021年至今，昊楼与其在十余个项目展开合作，1号楼·资管云系统和企业微信全面打通，以在空间运营管理系统搭建方面的专业能力为长江创服赋能，携手完成创业载体运营新升级。'],
      },
      {
        logo: require('../../assets/case/l13.png'),
        url: require('../../assets/case/b13.png'),
        title: '石榴集团',
        introduce: ['石榴集团创立于2007年，地产百强企业，以品质地产为起点。在伴随经济发展，社会发展，城市发展的进程中，根据不断变化的市场需求，逐渐构建起“科技+地产+金融”的全新发展模式，形成了帮助城市创新升级的产业竞争力。石榴集团与昊楼科技的合作始于2021年，昊楼为其深度打造了全面的资产管理体系，为其上海石榴中心开业奠定了数字化根基。']
      },
      {
        logo: require('../../assets/case/l14.png'),
        url: require('../../assets/case/b14.png'),
        title: '耕海联合中心',
        introduce: ['耕海联合中心项目位于北京市丰台区花乡夏家胡同，区位优势非常明显，交通便利。是北京三环内近年少数完工的新建办公楼之一，项目从设计到施工，都秉承着精益求精，尽善尽美的态度。2022年8月，昊楼科技与耕海联合中心牵手合作，以核心业务系统为切入点，搭建串联整个企业业务的数字化平台，打造“运营管理标准化”“客户服务精细化”“业务流程在线化”“管理数据可视化”的新型管理体系。']
      },
      {
        logo: require('../../assets/case/l15.png'),
        url: require('../../assets/case/b15.png'),
        title: '永泰地产',
        introduce: ['永泰房地产(集团)有限公司资产规模已逾40亿元，开发面积逾150万平方米，年销售额逾15亿元，形成以房地产为主导产业，集房地产经营、酒店、物业管理为一体的产业链。目前，公司正进行“集团化、跨区域、多项目”的战略布局。昊楼于2021年与其展开资产管理数字化建设的合作，尤其在财务管理上深耕细作，将财务管理的粒度精细化到天。']
      },
      {
        logo: require('../../assets/case/l16.png'),
        url: require('../../assets/case/b16.png'),
        title: '城奥置业',
        introduce: ['城奥大厦位于朝阳区北三环与北四环之间的奥体文化中心商务区、北京中轴线旁，紧邻地铁10号线安贞门站，南眺元大都公园，北依奥森氧吧，西邻2022年冬奥村。全生命周期BIM技术的应用，打造独特的非线性建筑外观，神似大拇指点赞。双方于2021年开启资产管理业务的合作。']
      },
      {
        logo: require('../../assets/case/l17.png'),
        url: require('../../assets/case/b17.png'),
        title: '中国光谷置业',
        introduce: ['武汉东湖新技术开发区简称东湖高新区，又称中国光谷、简称光谷，于1988年创建成立，是中国首批国家级高新区；经过30多年的发展，东湖高新区综合实力和品牌影响力大幅提升，知识创造和技术创新能力提升至全国169个国家级高新区第一，成为全国10家重点建设的“世界一流高科技园区”之一。昊楼与2020年便与其展开合作，为其打造资产管理和公寓管理的数字化体系。']
      },
      {
        logo: require('../../assets/case/l18.png'),
        url: require('../../assets/case/b18.png'),
        title: '亦庄城市服务集团',
        introduce: ['北京亦庄城市服务集团有限公司，成立于2005年12月14日，隶属于北京亦庄投资控股有限公司，是一家以物业服务和园区运营为主业、定位为”创新型城市服务商”的房地产综合服务企业。资产经营面积近100万平米，物业服务面积900余万平方米，涵盖公建、商业写字楼、产业园区、住宅、公寓、公租房等多个业态。双方于2018年以资管数字化为主展开合作，合作范围蕴含亦庄旗下所有经营资产，目前仍持续提供服务。']
      },
      {
        logo: require('../../assets/case/l19.png'),
        url: require('../../assets/case/b19.png'),
        title: '锦创',
        introduce: ['锦创科技股份有限公司创立于2004年，17年来汇聚创新实干的力量，形成智慧服务、产业园建设运营和科创载体综合服务三大业务板块，是智慧服务赋能商、城市更新服务商、科创载体服务运营商。旗下运营管理众创空间、孵化器、加速器10个，商业运营管理面积近10万㎡。双方于2021年展开合作，打造统一资管管理平台。']
      },
      {
        logo: require('../../assets/case/l20.png'),
        url: require('../../assets/case/b20.png'),
        title: '中南高科',
        introduce: ['中南集团旗下中南高科，致力于产业园、产业综合体和特色产业小镇三大主力产品线。中南高科目前已进入全国45个城市，拥有70多个产城和园区项目，超20万家企业客户。中南高科于2020年与昊楼全面合作，打造集“资源-物管”一体的系统平台，逐步管理上述项目。']
      },
      {
        logo: require('../../assets/case/l21.png'),
        url: require('../../assets/case/b21.png'),
        title: '当代置业',
        introduce: ['当代置业，地产百强企业，绿色地产代表型企业。2020年中与昊楼科技合作，对旗下数十个商业项目，以“1号楼”产品为基础搭建商业资产数字化平台，打通了8个系统，实现对资产、招商、运营、顾客信息的全面流程化、数据化、图形化管理，总管理面积近200万方。']
      },
    ]
  })
}
</script>
<style lang="scss" scoped>
.case {
  padding-bottom: 1.3rem;

  .content {
    width: 7.1rem;
    margin: 0.28rem auto 0;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    box-shadow:0 0 6px rgba(197, 205, 221, 1);
    padding-bottom: 10px;

    .pic {
      position: relative;
      margin-bottom: 10px;
      .logo {
        width: 0.88rem;
        height: 0.88rem;
        position: absolute;
        left: 50%;
        top: 0.8rem;
        transform: translate(-50%, 0);
        background-color: #fff;
        border-radius: 50%;

        img {
          background: none;
          margin: 0;
        }
      }
      img {
        display: block;
        width: 100%;
        background-color: #ddd;
        margin-bottom: 0.3rem;
      }
      h3 {
        position: absolute;
        text-align: center;
        left: 50%;
        top: 1.9rem;
        transform: translate(-50%, 0);
        color: #fff;
        font-size: 0.34rem;
        text-shadow: 1px 1px 4px rgba(60,60,60,0.8);
        white-space: nowrap;
      }
      .pos-left, .pos-right {
        position: absolute;
        bottom: 0.3rem;
        font-size: 0.7rem;
        color: #fff;
      }
      .pos-left {
        left: 0.6rem;
        font-size:0.6rem;
        text-shadow: 1px 1px 4px rgba(80,80,80,0.8);
      }
      .pos-right {
        right: 0.6rem;
        font-size:0.6rem;
      }
    }

    span {
      font-size: 0.26rem;
      color: #999;
      padding: 0 0.2rem;
      line-height: 0.42rem;
      display: block;
      text-align: justify;
    }
    h4 {
      font-size: 0.6rem;
      padding: 0.5rem;
      color: #3b5391;
    }
    p {
      font-size: 0.26rem;
      padding: 0 0.5rem;
      line-height: 0.42rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/case/index.vue